import React, { useState } from "react";
import axios from "axios";
import "./dashboard.css";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import "./editStudentsData.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const FetchStudents = () => {
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    useFatherName: false,
    useStudentName: false,
    useStudentClass: false,
    father_name: "",
    student_name: "",
    student_class: "",
  });

  const [students, setStudents] = useState([]);
  const [fatherNameSuggestions, setFatherNameSuggestions] = useState([]);
  const [studentNameSuggestions, setStudentNameSuggestions] = useState([]);

  const classes = [
    "Play Group",
    "Nursery",
    "Prep",
    "Class 1",
    "Class 2",
    "Class 3",
    "Class 4",
    "Class 5",
    "Class 6",
    "Class 7",
    "Class 8",
    "Class Pre 9",
    "Class 9",
    "Class 10",
  ];

  // Fetch father name suggestions
  const fetchFatherNameSuggestions = async (query) => {
    if (query.length >= 2) {
      try {
        const { data } = await axios.get(
          `https://mhsdev.online/search/student-father-name?query=${query}`
        );
        setFatherNameSuggestions(data || []);
      } catch (error) {
        console.error("Error fetching father name suggestions:", error);
      }
    } else {
      setFatherNameSuggestions([]);
    }
  };

  const fetchStudentNameSuggestions = async (query) => {
    if (query.length >= 2) {
      try {
        const { data } = await axios.get(
          `https://mhsdev.online/search/student-name?query=${query}`
        );
        setStudentNameSuggestions(data || []);
      } catch (error) {
        console.error("Error fetching student name suggestions:", error);
      }
    } else {
      setStudentNameSuggestions([]);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });

    if (name === "father_name") fetchFatherNameSuggestions(value);
    if (name === "student_name") fetchStudentNameSuggestions(value);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFilters({ ...filters, [name]: checked });
  };

  // Handle suggestion click
  const handleSuggestionClick = (suggestion, type) => {
    setFilters({ ...filters, [type]: suggestion });
    setFatherNameSuggestions([]);
    setStudentNameSuggestions([]);
  };

 // Fetch students based on filters
const fetchStudents = async () => {
    try {
      console.log("Sending data:", filters); // Log the data being sent
  
      // ✅ Show a loading SweetAlert while fetching data
      Swal.fire({
        title: "Searching...",
        text: "Please wait while we fetch student data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      await new Promise((resolve) => setTimeout(resolve, 1500)); // ✅ Simulated delay
  
      const response = await axios.get("https://mhsdev.online/fetch-students", {
        params: filters,
      });
  
      console.log(response.data);
  
      setStudents(response.data);
  
      // ✅ Close loading SweetAlert before showing success
      Swal.close();
    } catch (error) {
      console.error("Error fetching students data:", error);
  
      // ✅ Close loading alert before showing the error
      Swal.close();
  
      Swal.fire({
        title: "Error",
        text: "Failed to fetch students. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  

  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const handleUseID = async (studentid) => {
    setSelectedStudentId(studentid);
    console.log(studentid);
  
    try {
      // ✅ Show a loading SweetAlert while fetching data
      Swal.fire({
        title: "Processing...",
        text: "Please wait until we are done.............",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      await new Promise((resolve) => setTimeout(resolve, 1500)); // ✅ Simulated delay
  
      // ✅ Close the SweetAlert before navigation
      Swal.close();
  
      // ✅ Navigate after SweetAlert closes
      navigate(`/Fee-ApplyTo-Family-Student?FC=${studentid}`);
    } catch (error) {
      console.error("❌ Error in handleUseID:", error);
  
      // ✅ Show an error alert if something goes wrong
      Swal.fire({
        title: "Error!",
        text: "An error occurred while processing the request.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <div
        className="fetch-students-container"
        style={{ background: "rgb(255, 255, 255)" }}
      >
        <h2 style={{ background: "gold", color: "rgb(54, 4, 154)" }}>
          Search Family Code{" "}
        </h2>
        <div className="filters" style={{ marginRight: "2%" }}>
          {/* Student Name Filter */}
          <div className="filter">
            <input
              type="checkbox"
              name="useStudentName"
              checked={filters.useStudentName}
              onChange={handleCheckboxChange}
              style={{ width: "50px" }}
            />
            <label>Student Name</label>
            <input
              type="text"
              name="student_name"
              value={filters.student_name}
              onChange={handleInputChange}
              placeholder="Enter Name"
              disabled={!filters.useStudentName}
            />
            {studentNameSuggestions.length > 0 && (
              <ul
                className="suggestions"
                style={{
                  marginTop:
                    studentNameSuggestions.length === 1
                      ? "8%"
                      : studentNameSuggestions.length === 2
                      ? "10.5%"
                      : "16.3%",
                  marginLeft: "8%",
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {studentNameSuggestions.map((nameObj) => (
                  <li
                    key={nameObj.name}
                    onClick={() =>
                      handleSuggestionClick(nameObj.name, "student_name")
                    }
                  >
                    {nameObj.name}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Student ID Filter */}
          <div className="filter">
            <input
              type="checkbox"
              name="useFatherName"
              checked={filters.useFatherName}
              onChange={handleCheckboxChange}
              style={{ width: "50px" }}
            />
            <label>Father Name</label>
            <input
              type="text"
              name="father_name"
              value={filters.father_name}
              onChange={handleInputChange}
              placeholder="Enter Father's Name"
              disabled={!filters.useFatherName}
            />
            {fatherNameSuggestions.length > 0 && (
              <ul
                className="suggestions"
                style={{
                  marginTop:
                    fatherNameSuggestions.length === 1
                      ? "8%"
                      : fatherNameSuggestions.length === 2
                      ? "10.5%"
                      : "16.3%",
                  marginLeft: "8%",
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {fatherNameSuggestions.map((nameObj) => (
                  <li
                    key={nameObj.father_name}
                    onClick={() =>
                      handleSuggestionClick(nameObj.father_name, "father_name")
                    }
                  >
                    {nameObj.father_name}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Student Class Filter (Dropdown) */}
          <div className="filter">
            <input
              type="checkbox"
              name="useStudentClass"
              checked={filters.useStudentClass}
              onChange={handleCheckboxChange}
              style={{ width: "50px" }}
            />
            <label>Student Class</label>
            <select
              name="student_class"
              value={filters.student_class}
              onChange={handleInputChange}
              disabled={!filters.useStudentClass}
              style={{ borderRadius: "10px" }}
            >
              <option value="">Select Class</option>
              {classes.map((cls, index) => (
                <option key={index} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
          </div>

          {/* Search Button */}
          <button onClick={fetchStudents} className="search-button">
            Search
          </button>
        </div>

        {/* Display Students in a Table */}
        {/* Display Students in a Table */}
        {students.length > 0 && (
          <div className="student-table-container">
            <h3>Students List</h3>
            <div className="student-table-wrapper">
              <table className="student-table">
                <thead>
                  <tr>
                    <th style={{ display: "none" }}>ID</th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Student ID
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Name
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Father Name
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Mobile
                    </th>
                    <th style={{ display: "none" }}>B Form No</th>
                    <th style={{ display: "none" }}>Address</th>
                    <th style={{ display: "none" }}>Gender</th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Class
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Section
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Family Status
                    </th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Family Code
                    </th>
                    <th style={{ display: "none" }}>Created At</th>
                    <th style={{ display: "none" }}>Updated At</th>
                    <th
                      style={{ background: "rgb(54, 4, 154)", color: "gold" }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr key={student.id}>
                      <td style={{ display: "none" }}>{student.id}</td>
                      <td>{student.student_id}</td>
                      <td>{student.name}</td>
                      <td>{student.father_name}</td>
                      <td>{student.mobile}</td>
                      <td style={{ display: "none" }}>{student.b_form_no}</td>
                      <td style={{ display: "none" }}>{student.address}</td>
                      <td style={{ display: "none" }}>{student.gender}</td>
                      <td>{student.class}</td>
                      <td>{student.section}</td>
                      <td>{student.family_status}</td>
                      <td>{student.family_code}</td>
                      <td style={{ display: "none" }}>{student.created_at}</td>
                      <td style={{ display: "none" }}>{student.updated_at}</td>
                      <td>
                        <button
                          className="submit-button"
                          style={{
                            background:
                              "linear-gradient(to right,rgb(255, 230, 0),rgb(0, 12, 147))", // Red to Dark Red
                            color: "#fff", // White text
                            border: "none", // No border
                            padding: "4px 25px", // Adjusted padding for a balanced look
                            fontSize: "14px", // Readable font size
                            borderRadius: "4px", // Slightly rounded edges
                            cursor: "pointer", // Pointer cursor
                            display: "flex", // Flex for alignment
                            alignItems: "center", // Center align items
                            gap: "6px", // Space between icon and text
                            transition: "0.3s ease-in-out", // Smooth hover effect
                            width: "8rem", // Ensures text stays on one line
                            height: "32px", // Small height
                            justifyContent: "center", // Centers content inside
                          }}
                          onMouseOver={(e) => (e.target.style.opacity = "0.8")} // Hover effect
                          onMouseOut={(e) => (e.target.style.opacity = "1")} // Reset on mouse out
                          onClick={() => handleUseID(student.family_code)}
                        >
                          <span
                            className="icon-wrapper"
                            style={{ fontSize: "12pt", margin: 0 }}
                          >
                            <FaEdit />
                          </span>
                          USE ID
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FetchStudents;
